/**
 * Cross-platform secure cache for the license JWT.
 *
 * - On native (Tauri): callers should pass a storage adapter backed by the
 *   OS keychain via `@tauri-apps/plugin-stronghold` or `tauri-plugin-keyring`.
 * - On web/PWA: falls back to `localStorage` — acceptable since the token is
 *   signed (tampering is detected on verify) and the secret never leaves the server.
 */
export interface LicenseStorage {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}

export const LICENSE_TOKEN_KEY = "coach.license.token";
export const LICENSE_DEVICE_KEY = "coach.license.deviceId";

export const localStorageAdapter: LicenseStorage = {
  async get(key) {
    if (typeof localStorage === "undefined") return null;
    return localStorage.getItem(key);
  },
  async set(key, value) {
    if (typeof localStorage === "undefined") return;
    localStorage.setItem(key, value);
  },
  async remove(key) {
    if (typeof localStorage === "undefined") return;
    localStorage.removeItem(key);
  },
};
